<template>
    <div v-if="application!=null">
        <md-dialog-alert
            :md-active.sync="alertDialog.show"
            :md-title="alertDialog.title"
            :md-content="alertDialog.message"/>
        <!-- <group-card title="File Upload" icon="upload" class="" padded>
            <div class="md-layout">
                <md-field class="md-layout-item md-small-size-100 md-size-20">
                    <label>Choose a File</label>
                    <md-file type="file" name="file" @change="onFileChange" required
                             :disabled="isSubmitted || isDisabled" v-model="single"/>
                </md-field>
                <md-dialog :md-active.sync="showComplianceDialog" class="checkbox_div" :disabled="isDisabled">
                    <md-dialog-title>What are you uploading?</md-dialog-title>
                    <md-dialog-content>
                        <md-list>
                            <md-list-item v-for="items in application_checklists" v-bind:key="items.id">
                    <span class="md-list-item-text">
                        {{ items.display_name }}
                    </span>
                                <md-checkbox v-model="checklists_selected" :value="items.id"/>
                            </md-list-item>
                        </md-list>
                    </md-dialog-content>
                    <md-dialog-actions>
                        <md-button class="md-button md-raised fab md-primary" @click="showComplianceDialog=false">Save
                        </md-button>
                    </md-dialog-actions>
                </md-dialog>
            </div>
            <md-card-actions>
                <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate" v-if="isSaving"></md-progress-spinner>
                <md-button class="md-button md-raised fab md-primary" @click="save()" :disabled="isDisabled">Upload Files</md-button>
            </md-card-actions>
        </group-card> -->

        <group-card title="Generated Documents" icon="post_add" padded v-if="generatedFiles != null" class="checkbox_div">
            <md-list>
                <md-list-item v-for="items in generatedFiles" v-bind:key="items.id">
                    <span class="md-list-item-text">
                        {{ items.file_type }}
                    </span>
                </md-list-item>
            </md-list>
        </group-card>

        <group-card title="Compliance Checklist" icon="done" class="checkbox_div" padded>
            <template slot="actions">
                <loading-icon-button
                    @click="getCheckLists"
                    :loading="isLoading"
                >
                    refresh
                </loading-icon-button>
            </template>
            <md-list>
                <md-list-item v-for="items in application_checklists" v-bind:key="items.id">
                    <span class="md-list-item-text">
                        {{ items.display_name }}
                    </span>
                    <span class="md-list-item-text">
                        {{ items.description }}
                    </span>
                    <md-button 
                        class="md-just-icon md-primary md-simple" 
                        v-if="items.is_completed" 
                        :disabled="isDisabled"
                        @click="toggleCheckBox(items.id, 'remove')"
                    >
                        <md-icon>done</md-icon>
                        <md-tooltip md-direction="top">Click to uncheck</md-tooltip>
                    </md-button>
                    <md-button class="md-just-icon md-danger md-simple" :disabled="isDisabled" v-else @click="toggleCheckBox(items.id, 'add')">
                        <md-icon>close</md-icon>
                        <md-tooltip md-direction="top">Click to check</md-tooltip>
                    </md-button>
                </md-list-item>
            </md-list>
            <md-card-actions>
                <loading-icon-text-button
                    @click="sendForCompliance"
                    icon="send"
                    :loading="isLoading"
                    :disabled="isDisabled || isSubmitted"
                >
                    Send For Compliance
                </loading-icon-text-button>
            </md-card-actions>
        </group-card>
        <floating-comment-section v-model="application" :available-sections="availableSections" :current-sections="currentSections" />
    </div>
    <div v-else>
        <md-empty-state
            md-icon="highlight_off"
            md-label="Application Not Selected"
            md-description="Please select an application before proceeding.">
        </md-empty-state>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
import {GroupCard} from "@/components";
import LoadingIconButton from '@/components/LoadingIconButton';
import LoadingIconTextButton from "../components/LoadingIconTextButton";
import FloatingCommentSection from '@/components/Editors/FloatingCommentSection';
import { applicationValidation } from "@/components/utils/validation";

export default {
    components: {
        LoadingIconTextButton,
        GroupCard,
        LoadingIconButton,
        FloatingCommentSection,
    },
    data() {
        return {
            application_checklists: null,
            isSubmitted: false,
            file: null,
            single: null,
            checklists_selected: [],
            showComplianceDialog: false,
            isSaving: false,
            alertDialog: {
                show: false,
                title: '',
                message: ''
            },
            isLoading: false,
            generatedFiles: null,
            is_editable: true,
            is_recheck: false,
            availableSections: [
              'Compilance',
            ],
            currentSections: 'Compilance'
        }
    },
    computed: {
        ...mapGetters([
            'options',
            'application'
        ]),
        isDisabled(){
            return !this.is_editable;
        },
        validation() {
            return applicationValidation(this.application);
        },
        expense() {
            const obj = this.validation.expenses.perApplicant.find(
                (expense) =>
                expense.applicantId == this.applicant.id ||
                expense.applicantId ==
                    this.application.applicants.indexOf(this.applicant)
            );
            return obj.expense;
        },
        showLivingExpenseItem() {
            const hemExpenses = this.validation.living_expenses;
            // if expense less than living expense benchmark, show warning
            return this.expense < hemExpenses;
        }
    },
    watch: {
        'application_checklists'() {
            if(!this.is_editable) {
                this.showAlertDialog('Info', 'Compliance is locked for further update. Please contact settlement officer if you need to amend it.');
            }
        }
    },
    methods: {
        async getCheckLists() {
            if (this.application.loan.id) {
                this.isLoading = true;
                let result = await this.$store.dispatch('get_compliance_checklists', this.application.loan.id);
                if (!result) {
                    this.is_editable = false;
                    this.showAlertDialog('Error', 'Please submit settlement request before checking compliance.');
                    this.isLoading = false;
                    return;
                }
                let checklists = result.checklists.filter(item => {
                    const name = item.name?.toLowerCase();
                    if (name?.includes('reason for below benchmark')) {
                        return this.showLivingExpenseItem; // Only include if HEM condition applies
                    }
                    return true;
                });
                this.application_checklists = checklists;
                this.is_editable = result.is_editable;
                this.is_recheck = result.is_recheck;
                this.isLoading = false;
            } else {
                this.is_editable = false;
                this.showAlertDialog('Error', 'Please select an application before checking compliance.');
            }
        },
        onFileChange() {
            this.file = event.target.files[0];
            this.single = this.file.name;
            this.showComplianceDialog = true;
        },
        async save() {
            if (this.file != null) {
                this.isSaving = true;
                let data = {
                    'selected_checkboxes': this.checklists_selected,
                    'application_id': this.application.loan.id
                };
                let result = await axios.post('/api/v1/application/save_compliance_checkboxes', data);
                if (result) {
                    const config = {
                        headers: {'content-type': 'multipart/form-data'}
                    }
                    let fileParams = {
                        'application_id': this.application.loan.id,
                        'applicant_id': this.application.applicants[0].id,
                        'document_type': this.checklists_selected,
                    };
                    const formData = new FormData();
                    formData.append('file', this.file);
                    formData.append('fileParams', JSON.stringify(fileParams));
                    let fileUpload = await axios.post('/api/v1/application/upload_compliance_documents', formData, config);
                    if (fileUpload) {
                        this.isSaving = false;
                        this.showComplianceDialog = false;
                        this.showAlertDialog('Saved', 'Compliance documents have been uploaded');
                        await this.getCheckLists();
                        this.checklists_selected = [];
                        this.file = null;
                        this.single = null;
                    } else {
                        this.isSaving = false;
                        this.showAlertDialog('Error', result);
                    }
                }
            } else {
                this.showAlertDialog('Info', 'Please select a file before proceeding.');
            }
        },
        showAlertDialog(title, message) {
            this.alertDialog.show = true;
            this.alertDialog.title = title;
            this.alertDialog.message = message;
        },
        async toggleCheckBox(itemId, toggle) {
            this.isLoading = true;
            let data = {
                'selected_checkbox': itemId,
                'toggle': toggle,
                'application_id': this.$route.params.id
            }
            let result = await axios.post('/api/v1/application/toggle_compliance_checkboxes', data);
            if (result) {
                await this.getCheckLists();
            }
        },
        async sendForCompliance() {
            this.isLoading = true;
            let response = await axios.post(`/api/v1/application/${this.application.loan.id}/status`, {
                stage: 'Compliance',
                status: this.is_recheck ? 'Recheck' : 'Review',
                reason: 'Other',
                comment: this.is_recheck ? 'sent for compliance recheck' : 'sent for compliance review'
            });
            this.isLoading = false;
            if(response.status == 200) {
                await this.getCheckLists();
                this.showAlertDialog('Success', 'Application has been sent for compliance.');
            } else {
                this.showAlertDialog('Error', 'Could not send application for compliance.');
            }
        }
    },
    mounted() {
        this.getCheckLists();
    }
}
</script>
<style lang="scss" scoped>
.checkbox_div .md-ripple > span {
    position: relative;
}
</style>
